import React, { useEffect, useRef } from "react";
import Select from "react-select";
import {
  BlurWrapper,
  FloatLabel,
  customStylesForMultiSelect,
} from "../../Utils/CustomComponent";

const UseFormLabelInput = ({
  title,
  field,
  register,
  setValue,
  options,
  isMulti,
  watch,
  type,
  error,
  disable = false,
  blur = false,
  tooltipFlag = false,
  tooltip = {},
  placeholder = "",
  onInputChange = false,
  setInputChangeQuery,
  isLoading = false,
  setSelected = null,
  noOptionsMessage = () => "No options",
  isClearable = false
}) => {
  const value = options?.filter((data) => data.value === watch(field))[0];
  const selectRef = useRef(null);

  useEffect(() => {
    if (error && value === undefined && selectRef.current) {
      // This focuses the internal input of react-select
      selectRef.current.focus();
    }
  }, [error]);

  return (
    <div>
      <FloatLabel
        label={title}
        value={value}
        className={error && value === undefined ? "text-error" : ""}
      >
        {blur ? (
          <BlurWrapper>
            <Select
              name={field}
              ref={selectRef}
              placeholder={placeholder}
              isMulti={isMulti}
              options={options}
              // {...register(field)}
              value={value || null}
              onChange={(selected) => {
                if (isMulti) {
                  setValue(field, selected || []);

                  if (setSelected) {
                    setSelected(selected || []);
                  }
                } else {
                  setValue(field, selected?.value ?? null);

                  if (setSelected) {
                    setSelected(selected?.value ?? null);
                  }
                }
              }}
              styles={customStylesForMultiSelect}
              className={error && value === undefined ? "is-invalid" : ""}
              isDisabled={disable}
              menuPosition={blur ? "absolute" : "fixed"}
              onInputChange={
                onInputChange
                  ? (inputValue, actionMeta) => {
                      setInputChangeQuery(inputValue);
                    }
                  : null
              }
              isLoading={isLoading}
              isClearable={isClearable}
              noOptionsMessage={noOptionsMessage}
            />
          </BlurWrapper>
        ) : (
          <Select
            name={field}
            ref={selectRef}
            placeholder={placeholder}
            isMulti={isMulti}
            options={options}
            // {...register(field)}
            value={value || null}
            onChange={(selected) => {
              if (isMulti) {
                setValue(field, selected || []);

                if (setSelected) {
                  setSelected(selected || []);
                }
              } else {
                setValue(field, selected?.value ?? null);

                if (setSelected) {
                  setSelected(selected?.value ?? null);
                }
              }
            }}
            styles={customStylesForMultiSelect}
            className={error && value === undefined ? "is-invalid" : ""}
            isDisabled={disable}
            menuPosition="fixed"
            onInputChange={
              onInputChange
                ? (inputValue, actionMeta) => {
                    setInputChangeQuery(inputValue);
                  }
                : null
            }
            isLoading={isLoading}
             isClearable={isClearable}
            noOptionsMessage={noOptionsMessage}
          />
        )}
        <div className="invalid-feedback">{error}</div>
      </FloatLabel>
    </div>
  );
};

export default UseFormLabelInput;
